
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC"}},[_c('path',{attrs:{"d":"m28.806 4.998.558-.96H47.23l-.559.96zM19.194 4.998l-.558-.96H.77l.559.96zM28.13 6.16h17.864l-.59 1.015H27.538zM20.461 7.175 19.87 6.16H2.006l.59 1.016zM26.863 8.337h17.864l-.59 1.016H26.271zM21.728 9.353l-.591-1.016H3.273l.59 1.016zM25.596 10.515H43.46l-.591 1.016H25.005zM22.995 11.53l-.591-1.015H4.54l.591 1.016zM24.329 12.692l-.329.566-.329-.566H5.807l.591 1.017h35.204l.591-1.017zM40.926 14.87l-.591 1.016H7.665l-.591-1.016zM8.34 17.048h31.32l-.592 1.016H8.932zM9.608 19.226h28.784l-.591 1.016H10.199zM10.875 21.403h26.25l-.591 1.017H11.466zM12.142 23.581h23.716l-.591 1.016H12.733zM13.409 25.759H34.59L34 26.775H14zM14.676 27.937h18.648l-.591 1.016H15.267zM15.943 30.114h16.114l-.591 1.017H16.534zM17.21 32.292h13.58l-.591 1.016H17.8zM18.477 34.47h11.046l-.591 1.016h-9.864zM19.744 36.648h8.512l-.591 1.016h-7.33zM21.011 38.825h5.978l-.591 1.017h-4.796zM22.278 41.003h3.444l-.591 1.016h-2.262zM23.545 43.18h.91l-.455.782z"}}),_c('path',{attrs:{"d":"M29.364 4.038 24 13.258l-5.364-9.22h-8.573L24 27.992 37.937 4.038z"}})]),_c('path',{staticClass:"i-v2_2",attrs:{"stroke":"#234652","d":"m6.227 22.672 9.208 16.311 7.342-16.311m2.003-5.574c.824-2.122 2.337-3.826 4.243-4.778a7.65 7.65 0 0 1 6.052-.364c1.988.717 3.66 2.23 4.688 4.24s1.345 4.685.53 6.856-2.854 3.92-8.487 8.422-7.305 7.166-7.305 7.166h16.586"}})])
          )
        }
      }
    